import { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

const JiraCoverImage = memo(function JiraCoverImage(props) {
  return (
    <SvgIcon viewBox="0 0 76 32" {...props}>
      <g id="logo-gradient-blue-jira">
        <g id="Jira">
          <path
            d="M38.8963 6.13371H41.7283V20.1309C41.7283 23.8217 40.0434 26.3983 36.1359 26.3983C34.6661 26.3983 33.5189 26.1546 32.7302 25.876V23.195C33.5906 23.5432 34.6302 23.7173 35.6698 23.7173C38.0717 23.7173 38.8963 22.3245 38.8963 20.305V6.13371Z"
            fill="#253858"
          />
          <path
            d="M46.9266 5.05432C48.0379 5.05432 48.8266 5.71588 48.8266 6.89972C48.8266 8.04875 48.0379 8.74513 46.9266 8.74513C45.8152 8.74513 45.0266 8.08357 45.0266 6.89972C45.0266 5.7507 45.8152 5.05432 46.9266 5.05432ZM45.5285 10.9387H48.253V26.2591H45.5285V10.9387Z"
            fill="#253858"
          />
          <path
            d="M54.9924 26.2591H52.3395V10.9387H54.9924V13.6198C55.9244 11.8092 57.5018 10.5209 60.5848 10.695V13.2716C57.1075 12.9234 54.9924 13.9331 54.9924 17.2061V26.2591Z"
            fill="#253858"
          />
          <path
            d="M73.3112 23.5084C72.3075 25.5279 70.4075 26.5724 67.9697 26.5724C63.7754 26.5724 61.6603 23.1254 61.6603 18.5989C61.6603 14.2813 63.8829 10.6254 68.2924 10.6254C70.5867 10.6254 72.3792 11.6351 73.3112 13.6198V10.9387H76.0358V26.2591H73.3112V23.5084ZM68.6867 24.1351C71.1245 24.1351 73.2754 22.6379 73.2754 19.2256V18.007C73.2754 14.5947 71.3037 13.0975 68.9735 13.0975C65.9263 13.0975 64.349 15.0474 64.349 18.5989C64.3848 22.2897 65.8905 24.1351 68.6867 24.1351Z"
            fill="#253858"
          />
        </g>
        <g id="Icon">
          <path
            id="Vector"
            d="M24.664 3H12.2603C12.2603 5.99443 14.7697 8.43176 17.8527 8.43176H20.147V10.5557C20.147 13.5501 22.6565 15.9875 25.7395 15.9875V4.04457C25.7395 3.45265 25.2735 3 24.664 3Z"
            fill="#2684FF"
          />
          <path
            id="Vector_2"
            d="M18.5339 8.98877H6.13013C6.13013 11.9832 8.63956 14.4205 11.7226 14.4205H14.0169V16.5793C14.0169 19.5737 16.5264 22.0111 19.6094 22.0111V10.0333C19.6094 9.47623 19.1433 8.98877 18.5339 8.98877Z"
            fill="url(#paint0_linear)"
          />
          <path
            id="Vector_3"
            d="M12.4038 15.0125H0C0 18.0069 2.50943 20.4442 5.59245 20.4442H7.88679V22.5682C7.88679 25.5626 10.3962 27.9999 13.4792 27.9999V16.057C13.4792 15.4651 12.9774 15.0125 12.4038 15.0125Z"
            fill="url(#paint1_linear)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="19.3455"
          y1="9.01882"
          x2="14.2302"
          y2="14.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.176" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="13.5601"
          y1="15.0525"
          x2="7.63562"
          y2="20.9874"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.176" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
});

export default JiraCoverImage;
